import * as React from 'react'
const SVGComponent = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={160}
    height={145}
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    shapeRendering="geometricPrecision"
    vectorEffect="non-scaling-stroke"
    {...props}
  >
    <path
      d="M143.605 101.128C143.605 101.128 139.978 104.798 133.434 103.835C132.793 103.743 132.182 104.169 132.078 104.81C131.997 105.303 131.967 105.667 131.96 105.902C131.954 106.142 131.843 106.358 131.664 106.512L126.397 110.885C123.683 112.649 121.851 115.542 121.561 118.768C121.543 119.002 121.531 119.212 121.531 119.384L120.902 131.819C120.846 133.268 121.642 134.619 122.937 135.266C126.089 136.858 129.845 136.685 132.836 134.81L151.087 123.375C152.925 122.222 154.084 120.248 154.214 118.083C154.386 115.24 154.578 116.307 154.775 112.834C155.336 102.855 146.43 102.152 144.136 102.139C143.839 102.139 143.605 101.899 143.605 101.603V100.221"
      fill="white"
    />
    <path
      d="M143.605 101.128C143.605 101.128 139.978 104.798 133.434 103.835C132.793 103.743 132.182 104.169 132.078 104.81C131.997 105.303 131.967 105.667 131.96 105.902C131.954 106.142 131.843 106.358 131.664 106.512L126.397 110.885C123.683 112.649 121.851 115.542 121.561 118.768C121.543 119.002 121.531 119.212 121.531 119.384L120.902 131.819C120.846 133.268 121.642 134.619 122.937 135.266C126.089 136.858 129.845 136.685 132.836 134.81L151.087 123.375C152.925 122.222 154.084 120.248 154.214 118.083C154.386 115.24 154.578 116.307 154.775 112.834C155.336 102.855 146.43 102.152 144.136 102.139C143.839 102.139 143.605 101.899 143.605 101.603V100.221"
      stroke="currentColor"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      strokeWidth={0.75}
      strokeMiterlimit={10}
    />
    <path
      d="M147.787 85.3506C147.849 84.9621 149.526 83.0315 145.536 80.5891C141.545 78.1467 131.06 74.9271 128.938 78.4674C127.137 81.4649 128.994 85.2519 130.499 86.5287C130.832 86.8124 130.887 87.2688 130.677 87.6512C129.894 89.076 130.073 91.6726 132.219 93.0665C132.158 93.6709 132.09 94.5776 132.047 95.3363C131.997 96.1442 132.528 96.8658 133.317 97.057C133.317 97.057 133.447 92.7458 135.76 94.0348C136.814 94.6208 136.648 95.6755 136.284 96.5019C135.932 97.3099 136.05 98.2413 136.636 98.9012L136.864 99.1541C138.356 100.826 140.663 101.504 142.822 100.918L143.994 100.597L148.342 91.4875C149.477 89.8099 149.44 87.6019 148.243 85.9674L147.787 85.3445V85.3506Z"
      fill="currentColor"
      className="gray-element"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M133.891 101.177C133.891 101.177 128.451 101.307 128.198 96.3538C127.939 91.4011 129.709 84.0676 129.709 84.0676"
      stroke="black"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M132.799 101.22V103.731"
      stroke="black"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M132.466 123.239C132.466 123.492 131.652 135.445 131.652 135.445"
      stroke="black"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M16.2284 99.9375C16.2284 99.9375 19.855 103.607 26.399 102.645C27.0405 102.553 27.6511 102.978 27.7559 103.62C27.8361 104.113 27.8669 104.477 27.8731 104.711C27.8793 104.952 27.9903 105.168 28.1692 105.322L33.4364 109.695C36.1503 111.459 37.9821 114.352 38.272 117.577C38.2905 117.812 38.3028 118.021 38.3028 118.194L38.9319 130.628C38.9874 132.078 38.1918 133.429 36.8966 134.076C33.7448 135.667 29.9887 135.495 26.9973 133.62L8.74686 122.185C6.90886 121.031 5.74932 119.058 5.6198 116.893C5.4471 114.049 5.2559 115.116 5.05853 111.644C4.49727 101.665 13.4035 100.961 15.6979 100.949C15.994 100.949 16.2284 100.709 16.2284 100.412V99.0309"
      fill="white"
    />
    <path
      d="M16.2284 99.9375C16.2284 99.9375 19.855 103.607 26.399 102.645C27.0405 102.553 27.6511 102.978 27.7559 103.62C27.8361 104.113 27.8669 104.477 27.8731 104.711C27.8793 104.952 27.9903 105.168 28.1692 105.322L33.4364 109.695C36.1503 111.459 37.9821 114.352 38.272 117.577C38.2905 117.812 38.3028 118.021 38.3028 118.194L38.9319 130.628C38.9874 132.078 38.1918 133.429 36.8966 134.076C33.7448 135.667 29.9887 135.495 26.9973 133.62L8.74686 122.185C6.90886 121.031 5.74932 119.058 5.6198 116.893C5.4471 114.049 5.2559 115.116 5.05853 111.644C4.49727 101.665 13.4035 100.961 15.6979 100.949C15.994 100.949 16.2284 100.709 16.2284 100.412V99.0309"
      stroke="currentColor"
      strokeWidth={0.75}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M15.3155 79.1767C19.3061 76.7343 28.7859 76.8329 30.9076 80.3732C32.7086 83.3708 27.5215 84.2342 27.5894 86.2141C27.7868 92.055 27.6079 91.4937 27.6572 92.2524C27.7066 93.0603 27.17 93.782 26.3867 93.9732L26.1276 93.3194C26.1276 93.3194 25.3998 92.388 24.0738 92.8568C22.9389 93.2577 23.1856 94.4974 23.5495 95.3239C23.9011 96.1319 23.7839 97.0694 23.1979 97.7232L22.9697 97.976C21.4771 99.6475 19.1704 100.332 17.0117 99.74L15.8398 99.4193L11.7999 92.1968C9.48081 86.1586 11.3311 81.6376 15.3155 79.189"
      fill="currentColor"
      className="gray-element"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M25.9426 99.9867C25.9426 99.9867 31.3825 100.116 31.6354 95.1635C31.8945 90.2108 30.1243 82.8773 30.1243 82.8773"
      stroke="black"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M27.0343 100.03V102.534"
      stroke="black"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M27.3674 122.049C27.3674 122.302 28.1815 134.255 28.1815 134.255"
      stroke="black"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M20.8912 98.6175C20.8912 102.096 17.8443 104.921 14.0881 104.921C10.332 104.921 7.2851 102.096 7.2851 98.6175C7.2851 95.1389 10.332 92.3141 14.0881 92.3141C17.8443 92.3141 20.8912 95.1389 20.8912 98.6175Z"
      fill="currentColor"
      className="gray-element"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M97.1741 144.635H63.4549C60.4512 144.635 57.9286 142.551 57.6079 139.8C56.6334 131.529 56.7567 115.351 72.1268 113.241C90.3279 110.743 104.446 112.951 103.058 139.485C102.91 142.372 100.314 144.635 97.1803 144.635"
      fill="white"
    />
    <path
      d="M97.1741 144.635H63.4549C60.4512 144.635 57.9286 142.551 57.6079 139.8C56.6334 131.529 56.7567 115.351 72.1268 113.241C90.3279 110.743 104.446 112.951 103.058 139.485C102.91 142.372 100.314 144.635 97.1803 144.635H97.1741Z"
      stroke="currentColor"
      strokeWidth={0.75}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M65.6816 144.463C65.5336 143.784 65.9776 128.698 65.9776 128.698"
      stroke="black"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M94.3802 144.463C94.5282 143.784 94.0841 128.698 94.0841 128.698"
      stroke="black"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M85.7207 112.594L86.2696 109.127"
      stroke="black"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M74.668 108.615L75.2231 112.797"
      stroke="black"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M76.8144 89.6681C76.8144 89.6681 80.6877 86.3684 85.807 90.692C90.9262 95.0156 90.7042 108.104 85.696 109.356C80.6877 110.608 73.6318 110.268 73.2864 107.536C72.9472 104.804 66.2737 94.442 76.8144 89.6681Z"
      fill="currentColor"
      className="gray-element"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M42.7436 15.1244L40.0051 13.5516C39.2342 13.1075 38.2843 13.1014 37.5072 13.5331L1.13584 33.233C0.685592 33.4859 0.408042 33.9669 0.420378 34.485L0.574572 56.066C0.593075 56.8123 0.993982 57.497 1.6416 57.8794L6.17491 60.2355"
      fill="white"
    />
    <path
      d="M42.7436 15.1244L40.0051 13.5516C39.2342 13.1075 38.2843 13.1014 37.5072 13.5331L1.13584 33.233C0.685592 33.4859 0.408042 33.9669 0.420378 34.485L0.574572 56.066C0.593075 56.8123 0.993983 57.497 1.6416 57.8794L6.17491 60.2355"
      stroke="currentColor"
      strokeWidth={0.75}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M5.87888 35.478L41.4608 15.2971C42.3921 14.7667 43.5455 15.4389 43.5455 16.5121V38.6853C43.5455 39.1849 43.2802 39.6413 42.8485 39.8942L28.8292 48.0295L27.022 53.4077C26.7876 54.1109 25.8193 54.1726 25.4924 53.5065L24.1231 50.6878L7.67988 60.106C6.76088 60.6302 5.6075 59.9826 5.589 58.9217L5.17576 36.7178C5.16342 36.2058 5.4348 35.7309 5.88505 35.478"
      fill="white"
    />
    <path
      d="M5.87888 35.478L41.4608 15.2971C42.3921 14.7667 43.5455 15.4389 43.5455 16.5121V38.6853C43.5455 39.1849 43.2802 39.6413 42.8485 39.8942L28.8292 48.0295L27.022 53.4077C26.7876 54.1109 25.8193 54.1726 25.4924 53.5065L24.1231 50.6878L7.67988 60.106C6.76088 60.6302 5.6075 59.9826 5.589 58.9217L5.17576 36.7178C5.16342 36.2058 5.4348 35.7309 5.88505 35.478H5.87888Z"
      stroke="currentColor"
      strokeWidth={0.75}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M13.2678 43.4037C13.2678 43.4037 13.2123 43.379 13.1876 43.3605C12.0651 42.6204 12.0466 40.659 13.1506 38.9937C14.2546 37.3222 16.0618 36.5698 17.1843 37.3161C18.2884 38.0501 18.3192 39.9497 17.2707 41.6027C19.7316 41.5534 20.4471 44.2178 20.6136 45.106C20.6445 45.2725 20.5643 45.439 20.4163 45.5192L10.6527 50.9468C10.3936 51.0949 10.0667 50.9037 10.0729 50.6015C10.0852 49.189 10.4306 45.7844 13.2678 43.4037Z"
      fill="currentColor"
      className="gray-element"
    />
    <path
      d="M38.5743 25.1963L22.6677 34.2876"
      stroke="currentColor"
      strokeWidth={0.75}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M38.5743 29.7111L22.6677 38.8023"
      stroke="currentColor"
      strokeWidth={0.75}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M38.5743 34.2261L22.6677 43.3174"
      stroke="currentColor"
      strokeWidth={0.75}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M117.256 16.8267L119.995 15.2539C120.766 14.8098 121.716 14.8037 122.493 15.2354L158.864 34.9352C159.314 35.1881 159.592 35.6692 159.58 36.1873L159.426 57.7683C159.407 58.5146 159.006 59.1992 158.358 59.5816L153.825 61.9377"
      fill="white"
    />
    <path
      d="M117.256 16.8267L119.995 15.2539C120.766 14.8098 121.716 14.8037 122.493 15.2354L158.864 34.9352C159.314 35.1881 159.592 35.6692 159.58 36.1873L159.426 57.7683C159.407 58.5146 159.006 59.1992 158.358 59.5816L153.825 61.9377"
      stroke="currentColor"
      strokeWidth={0.75}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M154.127 37.1742L118.546 16.9933C117.614 16.4628 116.461 17.1351 116.461 18.2083V40.3814C116.461 40.881 116.726 41.3375 117.158 41.5903L131.177 49.7256L132.984 55.1039C133.219 55.807 134.187 55.8687 134.514 55.2026L135.883 52.3839L152.326 61.8021C153.245 62.3264 154.399 61.6788 154.417 60.6179L154.831 38.4139C154.843 37.902 154.571 37.4271 154.121 37.1742"
      fill="white"
    />
    <path
      d="M154.127 37.1742L118.546 16.9933C117.614 16.4628 116.461 17.1351 116.461 18.2083V40.3814C116.461 40.881 116.726 41.3375 117.158 41.5903L131.177 49.7256L132.984 55.1039C133.219 55.807 134.187 55.8687 134.514 55.2026L135.883 52.3839L152.326 61.8021C153.245 62.3264 154.399 61.6788 154.417 60.6179L154.831 38.4139C154.843 37.902 154.571 37.4271 154.121 37.1742H154.127Z"
      stroke="currentColor"
      strokeWidth={0.75}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M128.414 34.9845C128.414 34.9845 128.469 34.9598 128.494 34.9413C129.617 34.2012 129.635 32.2398 128.531 30.5745C127.427 28.9031 125.62 28.1506 124.497 28.8969C123.393 29.6309 123.363 31.5305 124.411 33.1835C121.95 33.1342 121.235 35.7986 121.068 36.6868C121.037 36.8533 121.117 37.0198 121.266 37.1L131.029 42.5277C131.288 42.6757 131.615 42.4845 131.609 42.1823C131.597 40.7698 131.251 37.3652 128.414 34.9845Z"
      fill="currentColor"
      className="gray-element"
    />
    <path
      d="M134.551 33.5968L150.464 42.682"
      stroke="currentColor"
      strokeWidth={0.75}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M134.551 38.1117L150.464 47.203"
      stroke="currentColor"
      strokeWidth={0.75}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M134.551 42.6263L150.464 51.7176"
      stroke="currentColor"
      strokeWidth={0.75}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M102.133 0.364746H57.978C56.8061 0.364746 55.8501 1.31457 55.8501 2.49262V21.6251C55.8501 22.7969 56.7999 23.7529 57.978 23.7529H77.573L79.559 27.4967C79.8797 28.095 80.7432 28.0765 81.0393 27.4659L82.8156 23.7529H102.133C103.305 23.7529 104.261 22.8031 104.261 21.6251V2.49262C104.261 1.32074 103.311 0.364746 102.133 0.364746Z"
      fill="white"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M102.133 0.364746H57.978C56.8061 0.364746 55.8501 1.31457 55.8501 2.49262V21.6251C55.8501 22.7969 56.7999 23.7529 57.978 23.7529H77.573L79.559 27.4967C79.8797 28.095 80.7432 28.0765 81.0393 27.4659L82.8156 23.7529H102.133C103.305 23.7529 104.261 22.8031 104.261 21.6251V2.49262C104.261 1.32074 103.311 0.364746 102.133 0.364746Z"
      stroke="currentColor"
      strokeWidth={0.75}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M102.133 3.64624H57.978C56.8061 3.64624 55.8501 4.59608 55.8501 5.77413V24.9066C55.8501 26.0784 56.7999 27.0344 57.978 27.0344H77.573L79.559 30.7783C79.8797 31.3765 80.7432 31.358 81.0393 30.7474L82.8156 27.0344H102.133C103.305 27.0344 104.261 26.0846 104.261 24.9066V5.77413C104.261 4.60225 103.311 3.64624 102.133 3.64624Z"
      fill="white"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M102.133 3.64624H57.978C56.8061 3.64624 55.8501 4.59608 55.8501 5.77413V24.9066C55.8501 26.0784 56.7999 27.0344 57.978 27.0344H77.573L79.559 30.7783C79.8797 31.3765 80.7432 31.358 81.0393 30.7474L82.8156 27.0344H102.133C103.305 27.0344 104.261 26.0846 104.261 24.9066V5.77413C104.261 4.60225 103.311 3.64624 102.133 3.64624Z"
      stroke="currentColor"
      strokeWidth={0.75}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M69.9682 13.1752C69.9682 15.0379 68.4756 16.5551 66.6314 16.5551C64.7873 16.5551 63.3008 15.044 63.3008 13.1752C63.3008 11.3064 64.7934 9.79529 66.6314 9.79529C68.4694 9.79529 69.9682 11.3064 69.9682 13.1752Z"
      fill="currentColor"
      className="gray-element"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M72.6265 19.8981C72.6265 16.9437 69.8263 14.5444 66.3785 14.5444C62.9307 14.5444 60.1306 16.9376 60.1306 19.8981C60.1306 19.8981 72.6326 20.1571 72.6326 19.8981"
      fill="currentColor"
      className="gray-element"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M76.2715 10.9055H97.9143"
      stroke="currentColor"
      strokeWidth={0.75}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M76.2715 14.9086H97.9143"
      stroke="currentColor"
      strokeWidth={0.75}
      strokeMiterlimit={10}
    />
    <path
      d="M76.2715 18.9052H97.9143"
      stroke="currentColor"
      strokeWidth={0.75}
      strokeMiterlimit={10}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
)
export default SVGComponent
